module.exports = __webpack_public_path__ + "img/privacidad_head.9f46d8f7.png";